import { createFileRoute } from "@tanstack/react-router"
import { PasskeyManagementPage } from "@/pages/PasskeyManagementPage"

export const Route = createFileRoute(
  "/_authenticated/_account/account-settings/security/passkey-management"
)({
  component: PasskeyManagementPage,
})
